import React from "react"
import { useApp } from "../context/AppContext"
import { Icon } from "./index.jsx"
import { Btn } from "./components"

/* ============================================================
   Modal dan dialog konfirmasi bersama. Dulu lokal di CourseManageScreen;
   dipindahkan apa adanya agar layar lain (mis. Kelola Program) memakai
   yang sama, bukan salinan kedua.
   ============================================================ */

// ── Generic modal shell ───────────────────────────────────────
export function Modal({ title, onClose, children, width = 480 }) {
  const { lang } = useApp()
  return (
    <div className="modal-overlay" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "grid", placeItems: "center", zIndex: 50, padding: 16 }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="tile" style={{ width, maxWidth: "100%", maxHeight: "90vh", overflowY: "auto", background: "var(--surface)" }}>
        <div className="tile-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid var(--border-subtle)" }}>
          <h3 style={{ margin: 0, fontSize: 15 }}>{title}</h3>
          <Btn variant="ghost" size="sm" icon={<Icon name="close" size={14} />} onClick={onClose} aria-label={lang === "id" ? "Tutup" : "Close"} />
        </div>
        <div style={{ padding: 16 }}>{children}</div>
      </div>
    </div>
  )
}

// ── Dialog konfirmasi (pengganti window.confirm untuk dokumen) ──
export function ConfirmModal({ title, message, confirmLabel, busy, onConfirm, onClose }) {
  const { lang } = useApp()
  return (
    <Modal title={title} onClose={busy ? () => {} : onClose} width={400}>
      <div className="col gap-3">
        <div className="small">{message}</div>
        <div className="row gap-2" style={{ justifyContent: "flex-end" }}>
          <Btn variant="ghost" type="button" disabled={busy} onClick={onClose}>{lang === "id" ? "Batal" : "Cancel"}</Btn>
          <Btn variant="danger" type="button" disabled={busy} onClick={onConfirm} autoFocus>{busy ? "…" : confirmLabel}</Btn>
        </div>
      </div>
    </Modal>
  )
}

export const inputStyle = { width: "100%", height: 34, padding: "0 10px", border: "1px solid var(--border-strong)", borderRadius: 6, fontSize: 13, fontFamily: "inherit" }
export const labelStyle = { fontSize: 12, fontWeight: 500, color: "var(--text-2)" }
